const load = async ({ request }) => {
  const terminalMode = request.headers.get("x-terminal-mode") === "true" || request.terminalMode === true;
  return {
    terminalMode
  };
};
export {
  load
};
